import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgCopy(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M5 2.75C4.30964 2.75 3.75 3.30964 3.75 4V24H6.25V5.25H20V2.75H5Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10 7.75C9.30964 7.75 8.75 8.30964 8.75 9V28C8.75 28.6904 9.30964 29.25 10 29.25H27C27.6904 29.25 28.25 28.6904 28.25 28V9C28.25 8.30964 27.6904 7.75 27 7.75H10ZM11.25 26.75V10.25H25.75V26.75H11.25Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCopy);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
